import React from 'react';
import styled from 'styled-components';

const LabelStyled = styled.div`
  display: flex;
  align-items: center;
  background: ${props => props.backColor};
  box-shadow: 0 2px 3px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  color: ${props => props.fontColor};
  font-family: Montserrat,serif;
  font-size: 13px;
  font-style: normal;
  font-weight: normal;
  line-height: 21px;
  margin: 5px 0 0 -5px;
  padding: 4px 6px;
  position: absolute;
  z-index: 10;
`;

const StyledIcon = styled.div`
  display: flex;
  margin-right: 8px;
`

const StyledText = styled.div`
  display: flex;
`

const Label = ({iconSvg, text, iconClass, backColor, fontColor}) => {
  let icon;
  if (iconClass !== undefined) {
    icon = `<i class="${iconClass}"/>`;
  } else if (iconSvg !== undefined) {
    icon = iconSvg;
  }

  return (
    <LabelStyled backColor={backColor} fontColor={fontColor} className="special-promo">
      <StyledIcon>{icon}</StyledIcon>
      <StyledText>{text}</StyledText>
    </LabelStyled>
  );
};

export default Label;
